import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage for web

import modalReducer from "./reducers/modal";
import authReducer from './reducers/auth'; // Adjust the path as needed
import generalReducer from "./reducers/general";

// Persist configuration for auth
const persistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'token', 'isLoggedIn', 'userId', 'cartsCount', 'wishsCount']
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    modals: modalReducer,
    auth: persistedAuthReducer,
    general: generalReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Ignore Redux Persist actions
      },
    }),
});

export const persistor = persistStore(store);

export default store;